export class Business {
	// TODO: Add models for all this stuff
	portfolioSettings: any;
	ezpayPortfolio: any;
	canonicalPortfolio: any;
	portalSettings: any;
	sessionId: string;
	businessTimezone: any;

	constructor(config: any) {
		if (config) {
			Object.assign(this, config);

			this.portfolioSettings = [];
			if (this.ezpayPortfolio != null) {
				this.portfolioSettings[this.ezpayPortfolioName] = this.ezpayPortfolio;
				this.ezpayPortfolio.portfolioName = this.ezpayPortfolioName;
			}

			this.canonicalPortfolio = null;
			if (this.ezpayPortfolio) {
				this.canonicalPortfolio = this.ezpayPortfolio;
			}
		}
	}

	get ezpayPortfolioName() { return '___ezpay'; }

	// Retrieve a singular portfolio whose settings can be used to determine what value a business-constant property might have.
	fetchCanonicalPortfolioSettings() {

		if (!this.canonicalPortfolio) {
			var portfolio = {
				settings: {
					isAccountTypeVisible: false,
					isAccountTypeRequired: false
				},
				merchantSettings: {
					portalRegistrationWithoutZipCode: false
				}
			};

			return portfolio;
		}

		return this.canonicalPortfolio;
	}

	fetchPortfolioSettings(portfolioName: any) {
		if (portfolioName) {
			return this.portfolioSettings[portfolioName];
		}
	}

	getMerchantZidAssociatedToPortfolioByPortfolioName(portfolioName: any) {
		var portfolioSettings = this.fetchPortfolioSettings(portfolioName);
		return portfolioSettings.merchantSettings.zid;
	}

	getMerchantKeyAssociatedToPortfolioByPortfolioName(portfolioName: any) {
		var portfolioSettings = this.fetchPortfolioSettings(portfolioName);
		return portfolioSettings.merchantSettings.merchantKey;
	}

	addCustomerPortfolios(customerPortfolios: any) {
		// clear the original array, we are going to put everything back in
		this.portfolioSettings.length = 0;

		if (this.ezpayPortfolio != null) {
			this.portfolioSettings[this.ezpayPortfolioName] = this.ezpayPortfolio;
		}
		if (customerPortfolios) {
			for (let ii = 0; ii < customerPortfolios.length; ++ii) {
				this.portfolioSettings[customerPortfolios[ii].name] = customerPortfolios[ii];
			}
		}

		// The canonical portfolio would preferably be a customer one, not ezpay.
		this.canonicalPortfolio = null;
		if (customerPortfolios && customerPortfolios.length > 0) {
			this.canonicalPortfolio = customerPortfolios[0];
		} else if (this.ezpayPortfolio) {
			this.canonicalPortfolio = this.ezpayPortfolio;
		}
	}

	//Everything but TOPS you requires zipcode to register. Tops can only have one merchant, so I am only checking the first item in the array.
	allowsPortalRegistrationWithoutZipCode() {
		var canonical = this.fetchCanonicalPortfolioSettings();
		if (canonical) {
			return canonical.merchantSettings.portalRegistrationWithoutZipCode;
		} else {
			return false;
		}
	}

	applyBusinessSettings(businessSettings: any) {
		this.portalSettings.applyBusinessSettings(businessSettings);
	}

	applyPortfolioSettingsToPortal(portfolioName: any, isForEzpay: any, merchantKey: number = 0) {
		let portfolio = this.fetchPortfolioSettings(portfolioName);
		this.portalSettings.applyPortfolioSettings(portfolio, isForEzpay, merchantKey);
	}
}
